"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var employeeAccess_exports = {};
__export(employeeAccess_exports, {
  isAccessIdAllowed: () => isAccessIdAllowed,
  isEmployeeAccessLimited: () => isEmployeeAccessLimited
});
module.exports = __toCommonJS(employeeAccess_exports);
function isEmployeeAccessLimited(access, bypass) {
  return !bypass && access?.limitEnabled === true;
}
__name(isEmployeeAccessLimited, "isEmployeeAccessLimited");
function isAccessIdAllowed(access, list, id, bypass) {
  if (!isEmployeeAccessLimited(access, bypass)) return true;
  return (list ?? []).includes(id);
}
__name(isAccessIdAllowed, "isAccessIdAllowed");
//# sourceMappingURL=employeeAccess.js.map
